<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <h2 class="common-title">支払い</h2>

      <!-- 認証済みの時はメインの画面を表示 -->
      <div v-if="signedIn">
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <div v-else-if="hasUserData">
          <template v-if="isAdviser">
            アドバイザーは課金できません
          </template>
          <template v-else-if="isStaff">
            運営アカウントは課金できません
          </template>
          <template v-else>
            <div class="guide-module item" v-if="$route.query.type === 'success'">
              <div class="guide-module-item">
                <h3 class="module-title">支払いが完了しました</h3>
                <span>ご利用ありがとうございます。<br>
                相談件数の上限はありませんので、お気軽にご相談ください。</span>
              </div>
              <div style="margin:0 0 10px 15px">
                <a :href="adviserLink" target="_blank">
                  <img :src="adviserImage" width="64px" style="border-radius:50%">
                </a> <b>{{adviserName}}</b>
              </div>
              <br>
              <div class="item">
                <form :action="paymentCustomerPortalApiUrl" method="POST">
                  <input type="hidden" name="customerId" :value="paymentCustomerId" />
                  <button type="submit">支払いの管理</button>
                </form>
              </div>
              <div class="item">
                <a href="/counselingDetail"><button class="footerNavi-button button-primary">新しい相談をしてみる</button></a>
              </div>
            </div>
            <div class="guide-module item" v-if="$route.query.type === 'canceled'">
              <div class="guide-module-item">
                <h3 class="module-title">支払いをキャンセルしました</h3>
                <span>支払い処理がキャンセルされました。<br>
                再度支払いをお試しください。</span>
              </div>
              <div style="margin:0 0 10px 15px">
                <a :href="adviserLink" target="_blank">
                  <img :src="adviserImage" width="64px" style="border-radius:50%">
                </a> <b>{{adviserName}}</b>
              </div>
              <div class="item">
                <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
              </div>
            </div>
            <div class="guide-module item" v-if="$route.query.type === 'error'">
              <div class="guide-module-item">
                <h3 class="module-title">支払い処理でエラーが発生しました</h3>
                <span>エラーが発生しました。<br>
                お手数おかけしますが、再度支払いをお試しください。</span>
              </div>
              <div style="margin:0 0 10px 15px">
                <a :href="adviserLink" target="_blank">
                  <img :src="adviserImage" width="64px" style="border-radius:50%">
                </a> <b>{{adviserName}}</b>
              </div>
              <div class="item">
                <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
              </div>
            </div>
          </template>

        </div>
        <div class="text-box" v-else>
          アカウント情報を設定してください
          <a class="link-button" href="/profileSetting">アカウント設定</a>
        </div>
      </div>

      <!-- 認証していない時はログイン画面を表示 -->
      <div v-else>
        <LoginItem :createButton="false" />
      </div>
    </main>
    <FooterItem :contactUrl="contactUrl" />
  </div>
</template>

<script>
import { API, Auth, graphqlOperation, Analytics, /*Logger*/ } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

//import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';


//const logger = new Logger('PaymentComplete');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'paymentComplete',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem,
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userId: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      contactUrl: '',
      isLoading: true,
      paymentCustomerId: '',
      paymentCustomerPortalApiUrl: '',
      adviserName: '',
      adviserLink: '',
      adviserImage: '',
    }
  },
  
  filters: {
  },

  methods: {
    
  },

  mounted: async function() {

  },
  
  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      this.paymentCustomerId = userData.data.listUsersBySpecificUser.items[0].paymentCustomerId
      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true 
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.$router.push({ path: '../dashboard' })
      }
    }

    // 課金モードの確認
    let paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)
    if (!paymentActiveStatus) {
      // 課金モード外のアクセスの場合はリダイレクト
      this.$router.push({ path: '../dashboard' })
    }

    // this.paymentCustomerId が空の場合はリロード
    let urlParam = window.location.search
    let params = new URLSearchParams(urlParam)
    let type = params.get('type')
    if (!this.paymentCustomerId && type === 'success') {
      location.reload(true)
    }
    
    this.paymentCustomerPortalApiUrl = 'https://' + this.getPaymentApiDomain(location.hostname) + '/subscription/customerPortal'
    this.isLoading = false

    var guideAdviser = this.getGuideAdviser(location.hostname)
    this.adviserName = guideAdviser.adviserName
    this.adviserLink = guideAdviser.adviserLink
    this.adviserImage = guideAdviser.adviserImage

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'PaymentComplete',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/user/paymentComplete',
        page_title: 'User:支払い完了'
      })
    }
  }
};
</script>

<style src="./assets/style.css" />
 